// extracted by mini-css-extract-plugin
export default {"colors":"EditFont_colors__Wc0e2","colorsColumn":"EditFont_colorsColumn__5Gb4c"};